import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Avatar,
  Grid,
  SxProps,
  Theme,
} from "@mui/material";
import useResponsive from "@/hooks/useResponsive";
import Heading from "./Heading";

interface IProps {
  title: string;
  subtitle: string;
  imageUrl: string;
  benefits: { iconUrl: string; description: string }[];
  sx?: SxProps<Theme>
}

const WhyTrackmateCard: React.FC<IProps> = ({
  title,
  subtitle,
  imageUrl,
  benefits,
  sx
}) => {
  const isMobile = useResponsive("down", "md");

  return (
    <Card
      sx={{
        ...sx,
        boxShadow: "none",
        borderRadius: "20px",
        padding: { xs: 3, md: 5 },
      }}
    >
      {isMobile && <Heading title={title} subtitle={subtitle} />}

      {/* Image */}
      <Box
        sx={{
          width: "auto",
          height: { xs: 228, sm: 375 },
          overflow: "hidden",
          boxSizing: "border-box",
          borderRadius: "20px",
          mb: { xs: 4, md: 7 }
        }}
      >
        <CardMedia
          component="img"
          image={imageUrl}
          alt={title}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Box>

      <CardContent sx={{ flex: "1 0 auto", padding: '0 !important' }} >
        {!isMobile && <Heading title={title} subtitle={subtitle} />}

        {/* Benefits */}
        <Grid container spacing={2}>
          {benefits.map(({ iconUrl, description }, index) => (
            <Grid item xs={6} key={index}>
              <Box display="flex" flexDirection="column">
                <Avatar
                  src={iconUrl}
                  sx={{
                    width: { xs: 18, sm: 24 },
                    height: { xs: 18, sm: 24 },
                    mb: { xs: 1, md: 1.5 }
                  }}
                />
                <Typography variant="body1" component='p'>{description}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

      </CardContent>
    </Card>
  );
};

export default WhyTrackmateCard;
